import { render, staticRenderFns } from "./StoryAttachments.vue?vue&type=template&id=725baccd&"
import script from "./StoryAttachments.vue?vue&type=script&lang=js&"
export * from "./StoryAttachments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports